import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { uniqueId } from "lodash";
import { Dropdown, DropdownButton, Form } from "react-bootstrap";
import { SECTION_ITEM_TYPE } from "@constants";
import { formatTimeHMS } from "@helpers";
import styles from "./styles/UnitItem.module.css";
import { filterRepeatFile } from "../Content/Assignment";

const UnitItem = (props) => {
  const { data: lessonInfo, currentLesson, onChange } = props;
  // state
  const unitRef = useRef();

  // variables
  let isCompleted = lessonInfo?.isCompleted || false;

  // logics before hooks

  // hooks
  useEffect(() => {
    if (currentLesson?.id === lessonInfo?.id) {
      document.documentElement.style.scrollBehavior = "smooth";
      unitRef?.current?.scrollIntoView();
    }
  }, [currentLesson]);

  // logics

  // UI partials
  const attachments = (data) => {
    if (!data || data.length === 0) return null;
    const attachments = filterRepeatFile(data);
    return (
      <DropdownButton
        size="sm"
        title={
          <>
            <i className="bi bi-folder2-open mr-2"></i>Resources
          </>
        }
        variant="outline-dark"
        className={styles.btnResource}
      >
        {attachments.map(
          (attachment, index) =>
            attachment.fileUrl && (
              <Dropdown.Item
                key={attachment.assignmentId || uniqueId()}
                href={attachment.fileUrl}
                target="_blank"
              >
                <i className="bi bi-file-earmark-arrow-down mr-2"></i>
                {attachment.name ? attachment.name : `Resource ${index + 1}`}
              </Dropdown.Item>
            )
        )}
      </DropdownButton>
    );
  };

  // effects

  // render
  return (
    <div
      className={clsx(styles.lectureItem, {
        [styles.lectureActive]: lessonInfo.id === currentLesson?.id,
      })}
      onClick={() => onChange(lessonInfo.id)}
      ref={unitRef}
    >
      <Form.Check
        type="checkbox"
        className={styles.checkbox}
        checked={isCompleted}
        readOnly={true}
      />
      <div className="d-flex flex-column flex-grow-1">
        <p className="m-0">{lessonInfo.title}</p>
        <p className={clsx("m-0 mt-1", styles.videoDuration)}>
          <div className={styles.lectureDetails}>
            <div>
              {lessonInfo.type === SECTION_ITEM_TYPE.LECTURE ? (
                <>
                  <i className="bi bi-play-circle mr-2"></i>
                  {formatTimeHMS(lessonInfo.totalTime)}
                </>
              ) : lessonInfo.type === SECTION_ITEM_TYPE.ASSIGNMENT ? (
                <i className="bi bi-file-earmark mr-2"></i>
              ) : (
                <>
                  <i className="bi bi-lightbulb mr-2"></i>
                  {lessonInfo.isShowTime
                    ? formatTimeHMS(
                        lessonInfo.timeLimit ? lessonInfo.timeLimit * 60 : 0
                      )
                    : "No time limit"}
                </>
              )}
            </div>
            {attachments(lessonInfo.attachments?.filter((att) => att.fileUrl))}
          </div>
        </p>
      </div>
    </div>
  );
};

/* required: display name */
UnitItem.displayName = "UnitItem";

/* required: props types */
UnitItem.propTypes = {
  data: PropTypes.object,
  onChange: PropTypes.func,
  currentLesson: PropTypes.object,
};

/* required: default props */
UnitItem.defaultProps = {};

export { UnitItem };
